export const REGEX_EXAMPLES = [
  { pattern: '^[0-9]+$', key: 'numbersOnly' },
  { pattern: '^[a-zA-Z]+$', key: 'lettersOnly' },
  { pattern: '^[a-zA-Z0-9]+$', key: 'alphanumericOnly' },
  { pattern: '^[A-Z]{2}\\d{6}$', key: 'twoLettersSixDigits' },
  { pattern: '^\\d{4}-\\d{2}-\\d{2}$', key: 'dateFormat' },
  { pattern: '^SN-[A-Z0-9]{8}$', key: 'serialNumber' },
  { pattern: '^\\S+$', key: 'noWhitespace' },
] as const;
